// extracted by mini-css-extract-plugin
module.exports = {"container":"Details_component_container__1ukzV","containerLoader":"Details_component_containerLoader__2H5OQ","listItemText":"Details_component_listItemText__vHszf"};